export function Mail() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M27.5 8.75L16.2612 15.9088C15.8799 16.1303 15.4467 16.2469 15.0056 16.2469C14.5646 16.2469 14.1314 16.1303 13.75 15.9088L2.5 8.75"
        stroke="var(--primary)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 5H5C3.61929 5 2.5 6.11929 2.5 7.5V22.5C2.5 23.8807 3.61929 25 5 25H25C26.3807 25 27.5 23.8807 27.5 22.5V7.5C27.5 6.11929 26.3807 5 25 5Z"
        stroke="var(--primary)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Call() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M17.29 20.71C17.5482 20.8286 17.839 20.8556 18.1146 20.7868C18.3902 20.718 18.6342 20.5573 18.8063 20.3312L19.25 19.75C19.4829 19.4395 19.7848 19.1875 20.132 19.0139C20.4791 18.8404 20.8619 18.75 21.25 18.75H25C25.663 18.75 26.2989 19.0134 26.7678 19.4822C27.2366 19.9511 27.5 20.587 27.5 21.25V25C27.5 25.663 27.2366 26.2989 26.7678 26.7678C26.2989 27.2366 25.663 27.5 25 27.5C19.0326 27.5 13.3097 25.1295 9.0901 20.9099C4.87053 16.6903 2.5 10.9674 2.5 5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H8.75C9.41304 2.5 10.0489 2.76339 10.5178 3.23223C10.9866 3.70107 11.25 4.33696 11.25 5V8.75C11.25 9.13811 11.1596 9.5209 10.9861 9.86803C10.8125 10.2152 10.5605 10.5171 10.25 10.75L9.665 11.1888C9.43552 11.364 9.27377 11.6132 9.20724 11.8942C9.1407 12.1751 9.17348 12.4705 9.3 12.73C11.0084 16.1998 13.818 19.006 17.29 20.71Z"
        stroke="var(--primary)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Support() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M3.75 13.75H7.5C8.16304 13.75 8.79893 14.0134 9.26777 14.4822C9.73661 14.9511 10 15.587 10 16.25V20C10 20.663 9.73661 21.2989 9.26777 21.7678C8.79893 22.2366 8.16304 22.5 7.5 22.5H6.25C5.58696 22.5 4.95107 22.2366 4.48223 21.7678C4.01339 21.2989 3.75 20.663 3.75 20V13.75ZM3.75 13.75C3.75 12.2726 4.04099 10.8097 4.60636 9.44481C5.17172 8.0799 6.00039 6.83971 7.04505 5.79505C8.08971 4.75039 9.3299 3.92172 10.6948 3.35636C12.0597 2.79099 13.5226 2.5 15 2.5C16.4774 2.5 17.9403 2.79099 19.3052 3.35636C20.6701 3.92172 21.9103 4.75039 22.955 5.79505C23.9996 6.83971 24.8283 8.0799 25.3936 9.44481C25.959 10.8097 26.25 12.2726 26.25 13.75M26.25 13.75V20C26.25 20.663 25.9866 21.2989 25.5178 21.7678C25.0489 22.2366 24.413 22.5 23.75 22.5H22.5C21.837 22.5 21.2011 22.2366 20.7322 21.7678C20.2634 21.2989 20 20.663 20 20V16.25C20 15.587 20.2634 14.9511 20.7322 14.4822C21.2011 14.0134 21.837 13.75 22.5 13.75H26.25Z"
        stroke="var(--primary)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 20V22.5C26.25 23.8261 25.7232 25.0979 24.7855 26.0355C23.8479 26.9732 22.5761 27.5 21.25 27.5H15"
        stroke="var(--primary)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Whatsapp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M7.5175 10.0077C7.66034 8.878 9.12847 7.34268 10.2936 7.51304L10.2917 7.51118C11.4256 7.72665 12.3232 9.67826 12.8294 10.5558C13.188 11.1925 12.9551 11.8376 12.6206 12.1098C12.1694 12.4735 11.4637 12.9754 11.6118 13.4792C11.875 14.375 15 17.5 16.537 18.3884C17.1188 18.7246 17.5406 17.8377 17.9009 17.3834C18.1626 17.0339 18.8083 16.825 19.4435 17.17C20.3923 17.7225 21.286 18.3646 22.1125 19.0875C22.5253 19.4325 22.6221 19.9424 22.3361 20.4812C21.8324 21.4304 20.3754 22.682 19.3178 22.4276C17.4705 21.9835 10 19.0875 7.60041 10.6975C7.46546 10.3006 7.49944 10.1506 7.5175 10.0077Z"
        fill="var(--primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 28.75C13.4705 28.75 12.6243 28.5859 11.25 28.125L8.61804 29.441C6.95578 30.2721 5 29.0634 5 27.2049V24.375C2.30819 21.865 1.25 18.9709 1.25 15C1.25 7.40609 7.40609 1.25 15 1.25C22.5939 1.25 28.75 7.40609 28.75 15C28.75 22.5939 22.5939 28.75 15 28.75ZM7.5 23.2879L6.70494 22.5465C4.61359 20.5965 3.75 18.4164 3.75 15C3.75 8.7868 8.7868 3.75 15 3.75C21.2133 3.75 26.25 8.7868 26.25 15C26.25 21.2132 21.2133 26.25 15 26.25C13.7679 26.25 13.19 26.1387 12.0449 25.7547L11.0606 25.4246L7.5 27.2049V23.2879Z"
        fill="var(--primary)"
      />
    </svg>
  );
}

export function Telegram() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8896 5.6197C29.287 3.68249 27.3843 2.07263 25.5396 2.78534L2.92815 11.5216C0.868169 12.3175 0.776382 15.1981 2.7815 16.1235L7.70565 18.3962L10.0481 26.5948C10.1698 27.0207 10.5077 27.3505 10.9365 27.4616C11.3652 27.5726 11.8207 27.4486 12.1339 27.1353L15.7423 23.527L20.7969 27.318C22.2641 28.4183 24.3774 27.6168 24.7459 25.8202L28.8896 5.6197ZM3.82915 13.8536L26.4406 5.11734L22.2969 25.318L16.375 20.8765C15.8774 20.5032 15.181 20.5527 14.7411 20.9926L13.1956 22.5381L13.66 19.9842L22.7589 10.8854C23.2018 10.4426 23.2485 9.74042 22.8684 9.24275C22.4883 8.74508 21.7986 8.60549 21.2549 8.91619L8.68907 16.0966L3.82915 13.8536ZM10.2212 18.1005L10.9792 20.7535L11.2702 19.1528C11.3157 18.9027 11.4364 18.6723 11.6162 18.4926L14.391 15.7178L10.2212 18.1005Z"
        fill="var(--primary)"
      />
    </svg>
  );
}
